import React from "react";
import {isMobile} from "react-device-detect";
import LiveSection from "./LiveSection";
import {Trans} from "react-i18next";
import {Link} from "react-router-dom";
import { STBBS_DOMAIN } from "constant/config";


const EmptyHomeSection = ({ loading = false, user_nick = '', broad= {}, style = null }) => {

    if (isMobile) {
        return (
            <section className="home" style={style}>
                {broad && <LiveSection loading={loading} broad={broad}/>}
                <div className="defaulte">
                    <p>
                        <strong>
                            <Trans user_nick={user_nick}>
                                {{user_nick}}
                                님의 채널에 오신 것을 환영합니다!
                            </Trans>
                        </strong>
                        <br/>
                        <Trans>채널 VOD와 글을 통해 소통해 보세요.</Trans>
                    </p>
                    <span>
                                <Trans>
                                    상단바의<em>글쓰기</em> 버튼을 터치하여
                                    <br/>
                                    VOD를 업로드하거나 게시글을 작성해 보세요.
                                </Trans>
                            </span>
                </div>
            </section>
        );
    } else {
        return (
            <section className="new_bs_wrap">
                <h3>
                    <Trans user_nick={user_nick}>
                        {{user_nick}}
                        님의 채널에 오신 것을 환영합니다!
                    </Trans>
                </h3>
                <div className="new_bs">
                    <div className="vod">
                        <h3 className="ic vod">
                            <a
                                href={`${STBBS_DOMAIN}/vodupload/index.php?bj_id=${global.bj_id}`}
                                rel="noopener noreferrer"
                                target="_blank"
                            >
                                VOD
                            </a>
                        </h3>
                        <p>
                            <Trans>재미있는 VOD를 업로드 해보세요.</Trans>
                            <br/>
                            <Trans>채널 방문 유저와 VOD를 통해 소통할 수 있습니다.</Trans>
                        </p>
                        <a
                            href={`${STBBS_DOMAIN}/vodupload/index.php?bj_id=${global.bj_id}`}
                            rel="noopener noreferrer"
                            target="_blank"
                            className="btn-basic"
                        >
                                    <span>
                                        <Trans>업로드 하러가기</Trans>
                                    </span>
                        </a>
                    </div>
                    <div className="board">
                        <h3 className="ic brd">
                            <Link to={`${global.bj_id}/post/write`}>
                                <Trans>게시글</Trans>
                            </Link>
                        </h3>
                        <p>
                            <Trans>게시글과 댓글을 통해 소통해 보세요.</Trans>
                            <br/>
                            <Trans>방송과 다양한 이야기를 주제로 이야기를 나눌 수 있습니다.</Trans>
                        </p>
                        <Link to={`${global.bj_id}/post/write`} className="btn-basic">
                                    <span>
                                        <Trans>게시글 쓰기</Trans>
                                    </span>
                        </Link>
                    </div>
                </div>
            </section>
        );
    }
}

export default EmptyHomeSection;